import { useTranslation } from 'react-i18next';

/**
 * Guards in-app navigation away from a dirty form. Call the returned function
 * with the form's dirty flag; it returns true when it is safe to leave (the form
 * is not dirty, or the user confirmed the prompt).
 *
 * Complements useBeforeUnloadWarning, which only covers full-page unloads
 * (refresh / tab-close). This covers in-app Cancel/Close. The browser BACK
 * button is NOT covered here — React Router v6 navigation blocking needs a data
 * router (the app uses <BrowserRouter>), tracked as a separate follow-up.
 */
export function useConfirmDiscard(): (isDirty: boolean) => boolean {
  const { t } = useTranslation();
  return (isDirty: boolean) =>
    !isDirty ||
    window.confirm(
      t('common.unsavedChangesConfirm', {
        defaultValue: 'You have unsaved changes. Leave without saving?',
      }),
    );
}
